import { categories } from '@/mocks/categories';

export default function Navbar() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 10);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    if (mobileOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => { document.body.style.overflow = ''; };
  }, [mobileOpen]);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-secondary-200/60'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 whitespace-nowrap">
            <span className="text-2xl font-black font-heading text-primary-600 tracking-tight">
              黑料舍
            </span>
            <span className="hidden sm:inline-block text-xs text-primary-500 font-medium border border-primary-300/60 bg-primary-100/70 px-2 py-0.5 rounded-full leading-tight">
              独家爆料
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            <Link
              to="/"
              className="px-3 py-2 text-sm font-medium text-foreground-700 hover:text-primary-600 rounded-lg hover:bg-primary-50 transition-colors whitespace-nowrap cursor-pointer"
            >
              首页
            </Link>
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className="px-3 py-2 text-sm font-medium text-foreground-700 hover:text-primary-600 rounded-lg hover:bg-primary-50 transition-colors whitespace-nowrap cursor-pointer"
              >
                {cat.name}
              </Link>
            ))}
            <Link
              to="/about"
              className="px-3 py-2 text-sm font-medium text-foreground-700 hover:text-primary-600 rounded-lg hover:bg-primary-50 transition-colors whitespace-nowrap cursor-pointer"
            >
              关于我们
            </Link>
          </div>

          <div className="hidden md:flex items-center gap-2">
            <button className="w-9 h-9 flex items-center justify-center rounded-lg bg-secondary-100 hover:bg-secondary-200 transition-colors cursor-pointer" aria-label="搜索">
              <i className="ri-search-line text-foreground-600 text-base"></i>
            </button>
            <button className="px-4 py-2 text-sm font-semibold bg-primary-500 text-background-50 rounded-lg hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer">
              我要爆料
            </button>
          </div>

          <button
            className="md:hidden w-9 h-9 flex items-center justify-center rounded-lg bg-secondary-100 hover:bg-secondary-200 transition-colors cursor-pointer"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="菜单"
          >
            <i className={`text-foreground-700 text-lg ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-secondary-200/60">
          <div className="px-4 py-3 flex flex-col gap-1">
            <Link to="/" onClick={() => setMobileOpen(false)} className="px-3 py-2.5 text-sm font-medium text-foreground-700 hover:text-primary-600 rounded-lg hover:bg-primary-50 transition-colors cursor-pointer">
              首页
            </Link>
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                onClick={() => setMobileOpen(false)}
                className="px-3 py-2.5 text-sm font-medium text-foreground-700 hover:text-primary-600 rounded-lg hover:bg-primary-50 transition-colors cursor-pointer"
              >
                {cat.name}
              </Link>
            ))}
            <Link to="/about" onClick={() => setMobileOpen(false)} className="px-3 py-2.5 text-sm font-medium text-foreground-700 hover:text-primary-600 rounded-lg hover:bg-primary-50 transition-colors cursor-pointer">
              关于我们
            </Link>
            <div className="mt-2 pt-2 border-t border-secondary-200/60">
              <button className="w-full px-4 py-2.5 text-sm font-semibold bg-primary-500 text-background-50 rounded-lg hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer">
                我要爆料
              </button>
            </div>
          </div>
        </div>
      )}
    </nav>
  );
}